import React, {
  FC, useMemo, useState, useEffect, useRef
} from 'react'
import { Button, Input, Tabs } from 'antd'
import { useToggle } from 'react-use'


import { ICaptchaImageResult } from '@pages/login/components/captchaImage/const'
import { ICaptchaSliderResult } from '@pages/login/components/captchaSlider/const'
import { IAppInfo } from '@pages/login/components/qrAdminCode/const'
import logoImg from '@assets/logo.png'

import userInfoStore from '@src/stores'
import styles from './index.module.less'
import CaptchaSlider from './components/captchaSlider'
import CaptchaImage from './components/captchaImage'
import EnterprisesModal from './components/EnterpriseModal'

import { IProps } from './const'
import {
  fetchLogin, isAbleLogin, changeAccount
} from './utils'
import { getQrCodeInfo } from './service'


const { TabPane } = Tabs
const InputGroup = Input.Group


/**
 * 登录内容
 * @param props
 * @constructor
 */
const LoginBody: FC = ({ children }) => {
  const { userInfo = {} } = userInfoStore.useContainer()
  useMemo(() => {
    if ((userInfo as any).cid) {
      // goIndex() // 测试先不放开
    }
  }, [])
  return (
    <div className={styles.loginWrap}>
      <div className={styles.bgColor} />
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <div className={styles.logo}>
            <img src={logoImg} alt="" />
          </div>
        </div>
        <div className={styles.headerContent} />
        <div className={styles.headerRight}>
          <a className={styles.headerRightItem} target="_blank" href="https://www.zhi-niao.com">
            知鸟官网
          </a>
        </div>
      </div>
      <div className={styles.context}>
        <div className={styles.formWrap}>
          <div className={styles.mainTitle}>欢迎来到知鸟开放平台</div>
          <div className={styles.loginBox}>
            {children}
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  )
}

// 二维码登录定时器
let timer1

/**
 * 登录界面
 * @constructor
 */
const Login: FC<IProps> = () => {
  // 验证类型(0: 图片验证码; 1: 滑块验证码;)
  const [captchaType, setCaptchaType] = useState<0 | 1>(1)
  // 帐号
  const [account, setAccount] = useState('')
  // 验证码图片使用的帐号
  const [accountCode, setAccountCode] = useState('-')
  const [password, setPassword] = useState('')
  const [slider, setSlider] = useState<ICaptchaSliderResult | null>(null)
  // 验证码
  const [imageCode, setImageCode] = useState<ICaptchaImageResult | null>(null)
  // appInfo
  const [appInfo, setAppInfo] = useState<IAppInfo>({} as IAppInfo)
  // 二维码等待市场
  const [timer1Total, setTimer1Total] = useState<number>(0)
  // // 二维码扫描确认
  // const [showScanConfirm] = useState<true|false>(false)

  // 扫描提示
  // const [showScanNotice, setShowScanNotice] = useState<true | false >(false)
  const [enterpriseId, setEnterpriseId] = useState('')
  const [enterpriseList, setEnterpriseList] = useState([] as any[])
  const [showEnterprise, toggleVisible] = useToggle(false)
  const resolve = useRef<(v: any) => string>(null)

  const checkLoginStatus = () => {
    timer1 = setInterval(() => {
      setTimer1Total(timer1Total => timer1Total + 2)
    }, 2000)
  }


  const refreshQrCode = async () => {
    const data = await getQrCodeInfo()
    const tokenString = appInfo.adminQRCodeLoginToken ? `${appInfo.adminQRCodeLoginToken},${data.adminQRCodeLoginToken}` : data.adminQRCodeLoginToken
    const adminQRCodeLoginToken = tokenString.indexOf(',') > -1 ? tokenString.split(',').slice(-2).toString() : tokenString
    setAppInfo({
      ...data,
      adminQRCodeLoginToken
    })
    setTimer1Total(0)
    checkLoginStatus()
  }

  const cb = () => {
    clearInterval(timer1)
  }

  const refreshQrStatus = (adminQRCodeLoginToken) => {
    fetchLogin({ adminQRCodeLoginToken })
  }

  const handleRefresh = async () => {
    await cb()
    refreshQrCode()
  }

  useEffect(() => {
    if (timer1Total >= 60) {
      cb()
      return
    }
    if (appInfo.adminQRCodeLoginToken) refreshQrStatus(appInfo.adminQRCodeLoginToken)
  }, [timer1Total])

  // 验证码
  const [tabKey, setTabKey] = useState<'1' | '2'>('2')
  const onTabChange = (activeKey) => {
    if (activeKey === '2') {
      cb()
    } else {
      handleRefresh()
    }
    setTabKey(activeKey)
  }
  useEffect(() => {
    // handleRefresh()
  }, [])

  const chooseEnterprise = async (enterpriceList) => {
    toggleVisible()
    setEnterpriseList(enterpriceList)
    return new Promise<string>((res) => {
      resolve.current?.(res)
    })
  }

  return (
    <LoginBody>
      <Tabs defaultActiveKey={tabKey} onChange={onTabChange}>
        {/* <TabPane tab="扫码登录" key="1">
          <div className={styles.scanCtx}>
            <div className={styles.imgContainer}>
              {showScanNotice ? <img src={scanNotice} alt="" /> : <img src={`data:image/png;base64,${appInfo.qrCodeBase64 || ''}`} alt="" /> }
              {showScanConfirm || (timer1Total >= 60) && (
                <div className={`${styles.scanConfirm} ${!showScanConfirm && styles.timeoutBG}`}>
                  <div className={styles.content}>
                    {showScanConfirm
                      ? (
                        <div>
                          <img className={styles.confirmImg} src={confirm} alt="" />
                          <span>已确认</span>
                        </div>
                      )
                      : (
                        <div className={styles.timeOut}>
                          <span className={styles.notice}>二维码已过期</span>
                          <div className={styles.refresh}><Button type="primary" onClick={handleRefresh}>刷新</Button></div>
                        </div>
                      )}
                  </div>
                </div>
              )}
            </div>
            <div>
              <div className={styles.scanTip}>请使用知鸟APP扫码</div>
              <div className={styles.help}>
                <span onMouseEnter={() => setShowScanNotice(true)} onMouseLeave={() => setShowScanNotice(false)}>使用帮助</span>
                <a href="http://www.zhi-niao.com/download.html" target="_blank">下载手机知鸟</a>
              </div>
              <div className={styles.appVersionTip}>
                <span>仅支持V5.0.4以上版本的APP进行扫码认证</span>
              </div>
            </div>
          </div>
        </TabPane> */}
        <TabPane tab="密码登录" key="2">
          <div className={styles.formCtx}>
            <InputGroup className={styles.accountBox} compact>
              {/* <AreaCode /> */}
              <Input
                className={`${styles.input} ${styles.account}`}
                placeholder="帐户"
                value={account}
                maxLength={11}
                autoComplete="off"
                onBlur={({ target: { value } }) => {
                  setAccountCode(value)
                }}
                onChange={(e) => {
                  const { value } = e.target
                  const val = value.replace(/\D/gi, '')
                  if (slider) {
                    slider.reset()
                  } else {
                    changeAccount(() => {
                      setAccountCode(val)
                    })
                  }
                  setAccount(val)
                }}
              />
            </InputGroup>
            <Input
              type="password"
              className={`${styles.input} ${styles.password}`}
              placeholder="密码"
              autoComplete="new-password"
              value={password}
              maxLength={40}
              onChange={({ target: { value } }) => {
                if (slider) {
                  slider.reset()
                }
                setPassword(value)
              }}
            />
            <div id="captcha-popup" className={styles.captchaPopup} />
            {captchaType === 1 ? (
              <CaptchaSlider
                changeCaptchaToImage={() => setCaptchaType(0)}
                onFinish={(o) => {
                  setSlider(o)
                }}
              />
            ) : (
              <CaptchaImage
                account={accountCode}
                onFinish={(o) => {
                  setImageCode(o)
                }}
              />
            )}
            <Button
              className={styles.submit}
              type="primary"
              disabled={!isAbleLogin(captchaType, account, password, slider)}
              onClick={() => {
                fetchLogin({
                  captchaType,
                  account,
                  password,
                  slider,
                  imageCode,
                  changeCaptchaToImage: () => setCaptchaType(0),
                }, chooseEnterprise)
              }}
            >
              <span>登录 </span>
            </Button>
          </div>
        </TabPane>
      </Tabs>
      <EnterprisesModal
        visible={showEnterprise}
        enterprises={enterpriseList}
        enterpriseId={enterpriseId}
        handleOk={() => {
          toggleVisible()
          resolve.current?.(enterpriseId)
        }}
        handleEnterpriseChange={setEnterpriseId}
      />
    </LoginBody>
  )
}

export default Login
